/**
 * @generated SignedSource<<29c7a290ba444ac9385be6b0dfbfbcc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainEditedInfo_Todo$data = {
  readonly updatedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly updatedBy: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "WorkspaceTodoEditMainEditedInfo_Todo";
};
export type WorkspaceTodoEditMainEditedInfo_Todo$key = {
  readonly " $data"?: WorkspaceTodoEditMainEditedInfo_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoEditMainEditedInfo_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};

(node as any).hash = "ef7979508ff9e56d9868b847b2cd00e4";

export default node;
